module.exports = __webpack_public_path__ + "static/media/sss-auto-pin.39ceb7c3.svg";